__turbopack_context__.v({
  "children": "-oE0pq_children",
  "container": "-oE0pq_container",
  "content": "-oE0pq_content",
  "slideInAnimation": "-oE0pq_slideInAnimation",
});
